
<div class="container mt-1">
  <div class="card shadow-sm">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-0">Final Approval</h4>
        
      </div>
      <button class="btn btn-secondary btn-sm" (click)="back()">Back</button>
    </div>
    <div class="card-body">
      <form>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Employee ID</label>
          <!-- <select class="form-select" [(ngModel)]="itfacilityreject_data.employeeid" name="employeeId" (change)="Onselectempolyee()">
            <option value="">Select Employee</option>
            <option *ngFor="let emp of employeeid" [value]="emp.OD_EmployeeID">{{ emp.OD_EmployeeID }}</option>
          </select> -->
        
          <input class="form-control" [(ngModel)]="itfacilityreject_data.MD_EmployeeId" name="MD_EmployeeId" />
        
        </div>
        
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Full Name</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.MD_Fullname" name="MD_Fullname" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">AD User Name</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.MD_ADUserName" name="MD_ADUserName" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Mail ID</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.MD_ADMailId" name="MD_ADMailId" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Designation</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.MD_Designation" name="MD_Designation" type="text" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">location</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.MD_Grade" name="MD_Grade" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Department</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.MD_Department" name="MD_Department" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Assert Type</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.MD_ReportingId" name="MD_ReportingId" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Microsoft Dynamic 360 Access</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.MD_Micsoftdynamic360" name="MD_Micsoftdynamic360" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Company Name</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.MD_company_name" name="MD_company_name" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">User Id</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.MD_UserId" name="MD_UserId" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Role Center</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.MD_RoleCenter" name="MD_RoleCenter" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Previlage Access</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.MD_Previlage_Access" name="MD_Previlage_Access" />
        </div>
        <!-- <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Other</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.Other" name="Other" />*ngIf="appservice.editchecker==='rejected'"
        </div>
        <div class="mb-3 d-flex align-items-center" >
  <label class="form-label me-3" style="width: 150px;">Comments</label>
  <textarea
  class="form-control"
  [(ngModel)]="itfacilityreject_data.command"
  name="command"
  style="height: 50px;"
  placeholder="Reason">
</textarea>

</div>-->

        <div class="action-buttons d-flex justify-content-start gap-2 mt-3">
          <button class="btn btn-approve" type="button" (click)="onApprove()">Submit</button><!-- " (click)="onApprove()(click)="onDecline()*ngIf="appservice.checkereditdata.status === 'Approved' *ngIf="appservice.checkereditdata.status === 'Rejected'-->
          
        </div>
      </form>
    </div>
  </div>
</div>
